<div class="container">
 
  <div class="row">
    <div class="col">
      <div class="login-page-container">
        <div class="login-page-logo">
          <img
            src="assets/images/logo-tr@3x.png"
            srcset="assets/images/logo-tr@3x.png 2x, assets/images/logo-tr@3x.png 3x"
            class="logo"
            width="70%"
          />
        </div>
        <div class="login-page-title">Log in</div>
        <div class="login-page-subtitle">
          Don't have an account?&nbsp;<a
            role="button"
            class="signup-link"
            routerLink="/register"
            >Sign up</a
          >
        </div>

        <div
          class="invalid-input"
          role="alert"
          *ngIf="responseError && responseError?.error"
        >
          {{ responseError?.error?.message }}
        </div>

        <div *ngIf="responseError?.error?.length > 0">
          <div
            class="invalid-input"
            role="alert"
            *ngFor="let error of responseError.error"
          >
            {{ error.message }}
          </div>
        </div>

        <form name="loginForm" [formGroup]="loginForm" novalidate>
          <div class="form-group">
            <div class="username">
              <label for="usernameId" class="form-label fs-14">Username or Email</label>
              <input
                type="text"
                autocomplete="off"
                placeholder="Username"
                formControlName="username"
                class="form-control mt-0 mb-3"
                id="usernameId"
                data-lpignore="true"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="password position-relative">
              <label for="passwordId" class="form-label fs-14">Password</label>
              <input
                type="{{ showPassword ? 'text' : 'password' }}"
                placeholder="Password"
                formControlName="password"
                autocomplete="new-password"
                class="form-control mt-0 pr-5"
                id="passwordId"
                data-lpignore="true"
              />
              <span class="password-toggle-icon" (click)="togglePasswordVisibility()">
                <i [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <div class="remember-me-checkbox">
                  <input type="checkbox" id="password-remember" />
                  <label for="password-remember">Remember me</label>
                </div>
              </div>
              <div class="col-md-6 text-end">
                <div class="forgot-your-password">
                  <a role="button" routerLink="/forgot-password"
                    >Forgot your password?</a
                  >
                </div>
              </div>
            </div>
          </div>
          <button
            class="btn btn-primary w-100"
            (click)="loginFormSubmit()"
            [disabled]="loginForm.invalid || isLoader"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
